import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useEffect, useState } from 'react';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import {
  Breadcrumbs,
  NoDataVisual,
  PageTitleAndSubTitle,
  Document,
  Comment,
  Tag,
  DashedStandardDropdown,
  WasteCalculatorCard,
  Tick,
  Tooltip,
  Minus,
  Button,
  Contract,
  Chat,
  SvgTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import TabSelection from '../../_components/molecules/TabSelection';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import ContractSideNavigationBar from '../../_components/organisms/ContractSideNavigationBar';
import properties from '../../core-utils/properties';
import axios from 'axios';
import Snackbar from '../../_components/atoms/Snackbar';
import {
  createBlobUrl,
  Fee,
  formatFeesProvisions,
  formatMatrixData,
  formatNewProvisions,
  getFeatureTabName,
  getOrderedTabsByAgreement,
  getReportStatusText,
  MatrixData,
} from '../../core-utils/helper-utils/contractAIQHelper';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import ContractReport from '../../../public/Images/AccessDashboard/ContractReport.png';
import {
  COMPENSATION_TRANSPARENCY_REPORT,
  DRAFT_AGREEMENTS,
  EXPERICENCE_SCREEN,
  GAG_CLAUSE_REPORT,
  INTER_CONTRACT_REPORT,
  PROPOSAL_ANALYZER,
  PURCHASING_STANDARDS_REPORT,
} from '../../core-utils/routes';
import { Columns as MatrixColumns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/MatrixTable';
import SvgInfo from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/Info';
import { observer } from 'mobx-react';
import DataExtraction from '../../../public/Images/DataExtraction.png';
import MergeDocuments from '../../../public/Images/MergeDocs.png';
import { handleDownloadReport } from '../../core-utils/helper-utils/contractReportHelper';
import { UserAccessConstants } from '../../core-utils/helper-utils/userAccess';
import ProvisionMatrix from '../../_components/organisms/ProvisionMatrix';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import { DocumentDetailsDataType } from '../../core-utils/helper-utils/termCompilerHelper';
import PdfHighlighter from '../../_components/organisms/PdfHighlighter';
import { DottedText } from '../../core-utils/helper-utils/financialForensicsHelper';
import {
  getChatHistory,
  sendChatMessage,
  ChatMessage,
  initialiseChatWithFile,
} from '../../core-utils/services/chatService';
import { v4 as uuidv4 } from 'uuid';
import ReactMarkdown from 'react-markdown';
import { DynamicFilter } from '../../_components/molecules/DynamicFilter';
import { handleDownloadCSV } from '../../core-utils/helper-utils/downloadPdfHelper';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import {
  regenerateMetadata,
  regenerateReport,
} from '../../core-utils/axios/compliance-assurance/contracts';
import { PDF_WORKER_URL } from '../../core-utils/helper-utils/pdfWorker';

export interface locationProps {
  state: {
    isDraft: boolean;
    draftName: string;
    contract: string;
    isDocumentView?: boolean;
    healthcarePartner: string;
    isReportsTab?: boolean;
    selectedTab?:
      | 'Key Terms'
      | 'Red Flags'
      | 'Missing Provisions'
      | 'Stop loss'
      | 'Compliance Analysis';
    isProposal?: boolean;
    isExperience?: boolean;
  };
}

const useStyles = makeStyles()({
  breadcrumbs: {
    padding: '12px 20px',
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
  },
  titleSubtitle: {
    padding: '24px 64px',
  },
  rightView: {
    width: '45%',
  },
  title: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '60vw',
    whiteSpace: 'nowrap',
  },
  documentViewRoot: {
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
  },
  documentViewContainer: {
    display: 'flex',
    gap: '24px',
    position: 'relative',
    padding: '24px 0px 36px 64px',
    flex: 1,
  },
  documentViewGrid: {
    padding: '0px',
    width: '100%',
    height: '519px',
    overflowY: 'auto',
    ...scrollBarStyles,
  },
  documentSection: {
    flex: 2,
  },
  chatSection: {
    flex: 1,
    position: 'sticky',
    top: '24px',
    alignSelf: 'flex-start',
    height: '100vh',
    '& > *': {
      height: '100vh',
    },
    maxWidth: '400px',
    paddingRight: '16px',
  },
  documentDropdown: {
    display: 'flex',
    alignItems: 'center',
  },
  metadataRoot: {
    paddingLeft: '64px',
  },
  tabs: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  tabContent: {
    padding: '30px 0px 36px 0px',
    width: '100%',
    overflowY: 'auto',
    height: '65vh',
    ...scrollBarStyles,
  },
  iconStyle: {
    height: '24px',
    width: '24px',
  },
  overview: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
  },
  ellipses: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '200px',
    whiteSpace: 'nowrap',
    '&:hover': {
      overflow: 'visible',
      whiteSpace: 'normal',
      height: 'auto',
    },
  },
  text: {
    flex: 1,
    padding: '16px',
  },
  reports: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  eachReport: {
    margin: '0px 32px 32px 0px',
  },
  provisionGrid: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '300px',
  },
  iconWrapper: {
    width: '16px',
    height: '16px',
    marginLeft: '4px',
  },
  flex: {
    display: 'flex',
    gap: '24px',
  },
  parameterBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const getBooleanCell = (value: any) => (
  <div>
    {typeof value === 'boolean' ? (
      value ? (
        <Tick color="#7C98B6" />
      ) : (
        <Minus />
      )
    ) : (
      value
    )}
  </div>
);

// Markdown Message Component for AI responses
const MarkdownMessage: React.FC<{ content: string }> = ({ content }) => {
  return (
    <ReactMarkdown
      components={{
        // Customize rendering for different markdown elements

        p: ({ node, ...props }: any) => (
          <Typography
            fontSize="14px"
            lineHeight="21px"
            fontType="regular"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="0 0 8px 0"
            {...props}
          />
        ),

        h1: ({ node, ...props }: any) => (
          <Typography
            fontSize="20px"
            lineHeight="28px"
            fontType="bold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="16px 0 8px 0"
            {...props}
          />
        ),

        h2: ({ node, ...props }: any) => (
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="bold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="14px 0 8px 0"
            {...props}
          />
        ),

        h3: ({ node, ...props }: any) => (
          <Typography
            fontSize="16px"
            lineHeight="24px"
            fontType="semiBold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="12px 0 8px 0"
            {...props}
          />
        ),

        code: ({ node, inline, ...props }: any) =>
          inline ? (
            <code
              style={{
                backgroundColor: patientAccessTheme.palette.grey[100],
                padding: '2px 6px',
                borderRadius: '4px',
                fontSize: '13px',
                fontFamily: 'monospace',
              }}
              {...props}
            />
          ) : (
            <pre
              style={{
                backgroundColor: patientAccessTheme.palette.grey[100],
                padding: '12px',
                borderRadius: '8px',
                overflow: 'auto',
                fontSize: '13px',
                fontFamily: 'monospace',
                margin: '8px 0',
              }}
            >
              <code {...props} />
            </pre>
          ),

        ul: ({ node, ...props }: any) => (
          <ul
            style={{
              margin: '8px 0',
              paddingLeft: '24px',
            }}
            {...props}
          />
        ),

        ol: ({ node, ...props }: any) => (
          <ol
            style={{
              margin: '8px 0',
              paddingLeft: '24px',
            }}
            {...props}
          />
        ),

        li: ({ node, ...props }: any) => (
          <li
            style={{
              marginBottom: '4px',
              fontSize: '14px',
              lineHeight: '21px',
              color: patientAccessTheme.palette.text.highemphasis,
            }}
            {...props}
          />
        ),

        strong: ({ node, ...props }: any) => (
          <strong
            style={{
              fontWeight: 600,
              color: patientAccessTheme.palette.text.highemphasis,
            }}
            {...props}
          />
        ),

        a: ({ node, ...props }: any) => (
          <a
            style={{
              color: patientAccessTheme.palette.primary[500],
              textDecoration: 'none',
            }}
            {...props}
          />
        ),

        blockquote: ({ node, ...props }: any) => (
          <blockquote
            style={{
              borderLeft: `4px solid ${patientAccessTheme.palette.primary[500]}`,
              paddingLeft: '16px',
              margin: '8px 0',
              fontStyle: 'italic',
              color: patientAccessTheme.palette.text.mediumemphasis,
            }}
            {...props}
          />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

const ContractDetails = observer(() => {
  //constants
  const messages = contractAIQConstants;
  const navigate = useNavigate();
  const location: locationProps = useLocation();
  // selected tab from experience screen
  const isDraft = location?.state?.isDraft || false;
  const isExperience = location?.state?.isExperience;
  const isProposal = location?.state?.isProposal;
  const draftName = location?.state?.draftName;
  const selectedTabFromExp = location?.state?.selectedTab;
  const contractStore = useStores().contractAiqStore;
  const employerGroupStore = useStores().employerGroupStore;
  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  const loginPageStore = useStores().loginPageStore;
  const { classes } = useStyles();
  const { openSnackbar, handleCloseSnackBar, snackbarState } = useSnackbar();
  const icons = [
    <Document className={classes.iconStyle} />,
    <Tag className={classes.iconStyle} />,
    <Comment className={classes.iconStyle} />,
  ];
  const customButtonVariant: Array<'contained' | 'outlined'> = [];
  const customButtonClick: (() => void)[] = [];
  const customButtonWidth: string[] = [];
  const customButtonText: string[] = [];
  const [contract] = useState(location?.state?.contract ?? '');

  const matrixColumns: MatrixColumns[] = [
    {
      header: 'Provision Name',
      accessor: 'provision',
      isSortEnabled: true,
      cell: (value: any, row: any) => (
        <div className={classes.provisionGrid}>
          <div>{value}</div>
          {row?.tooltip?.description && (
            <Tooltip
              title={
                <>
                  <Typography
                    fontSize="13px"
                    lineHeight="19.5px"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.status.white}
                  >
                    {row?.tooltip?.description}
                  </Typography>
                  <Typography
                    fontSize="13px"
                    lineHeight="19.5px"
                    fontType="regular"
                    textColor={patientAccessTheme.palette.status.white}
                    margin="8px 0px 0px 0px"
                  >
                    {row?.tooltip?.explaination?.replace(/\?/g, '')}
                  </Typography>
                </>
              }
              placement="bottom"
            >
              <div className={classes.iconWrapper}>
                <SvgInfo />
              </div>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      header: 'Value',
      accessor: 'value',
      cell: getBooleanCell,
      align: 'center',
    },
  ];
  const feesColumns: MatrixColumns[] = [
    {
      header: 'Fee',
      accessor: 'provision',
      // isSortEnabled: true,
      cell: (value: any, row: any) => (
        <div className={classes.provisionGrid}>
          <div>{value}</div>
          {row?.tooltip?.description && (
            <Tooltip
              title={
                <Typography
                  fontSize="13px"
                  lineHeight="19.5px"
                  fontType="semiBold"
                  textColor={patientAccessTheme.palette.status.white}
                >
                  {row?.tooltip?.description}
                </Typography>
              }
              placement="bottom"
            >
              <div className={classes.iconWrapper}>
                <SvgInfo />
              </div>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      header: 'Benchmark Cost',
      accessor: 'benchmark',
      align: 'center',
    },
    {
      header: 'Value',
      accessor: 'value',
      cell: getBooleanCell,
      align: 'center',
    },
  ];
  const summaryColumns: MatrixColumns[] = [
    {
      header: 'Name',
      accessor: 'name',
      align: 'left',
    },
    {
      header: 'Findings',
      accessor: 'value',
      align: 'center',
    },
    {
      header: 'Proposed Corrected Language',
      accessor: 'proposed_correct_language',
      align: 'center',
    },
    {
      header: 'Minimal Acceptable Language',
      accessor: 'minimal_acceptable_language',
      align: 'center',
    },
    {
      header: 'Business Impact',
      accessor: 'business_impact',
      align: 'center',
    },
  ];
  const breadcrumbsItemsList = isDraft
    ? isExperience
      ? [
          [
            'text',
            'Experience',
            {
              color: patientAccessTheme.palette.primary[500],
              fontWeight: 500,
            },
            () => {
              navigate(EXPERICENCE_SCREEN);
            },
          ],
          [
            'text',
            `${draftName}`,
            {
              color: patientAccessTheme.palette.text.highemphasis,
              fontWeight: 600,
            },
          ],
        ]
      : isProposal
      ? [
          [
            'text',
            'Proposal',
            {
              color: patientAccessTheme.palette.primary[500],
              fontWeight: 500,
            },
            () => {
              navigate(PROPOSAL_ANALYZER);
            },
          ],
          [
            'text',
            `${draftName}`,
            {
              color: patientAccessTheme.palette.text.highemphasis,
              fontWeight: 600,
            },
          ],
        ]
      : [
          [
            'text',
            'Draft',
            {
              color: patientAccessTheme.palette.primary[500],
              fontWeight: 500,
            },
            () => {
              navigate(DRAFT_AGREEMENTS);
            },
          ],
          [
            'text',
            `${draftName}`,
            {
              color: patientAccessTheme.palette.text.highemphasis,
              fontWeight: 600,
            },
          ],
        ]
    : [
        [
          'text',
          'Contract',
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            navigate('/contract');
          },
        ],
        [
          'text',
          `${contract}`,
          {
            color: patientAccessTheme.palette.text.highemphasis,
            fontWeight: 600,
          },
        ],
      ];

  //States
  const [loading, setLoading] = useState<boolean>(true);
  const [docLoading, setDocLoading] = useState<boolean>(true);
  const [loader] = useState<any>(<Loader />);
  const [healthcarePartner] = useState(
    location?.state?.healthcarePartner ?? '',
  );
  const [isDocumentView, setIsDocumentView] = useState<boolean>(
    location?.state?.isDocumentView as boolean,
  );
  const [showCustomButtons, setShowCustomButtons] = useState<boolean>(true);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const [tabList, setTabList] = useState<string[]>([]);
  const [documents, setDocuments] = useState<any[]>([]);
  const [masterDoc, setMasterDoc] = useState<any>();
  const [selectedDoc, setSelectedDoc] = useState<{
    document_name: string;
    document_url: string;
    original_url?: string;
    _id: string;
  }>({
    document_name: '',
    document_url: '',
    original_url: '',
    _id: '',
  });
  const [contractStatus, setContractStatus] = useState<string>('');
  const [tabLoading, setTabLoading] = useState<boolean>(true);
  const [
    documentDetails,
    setDocumentDetails,
  ] = useState<DocumentDetailsDataType>({
    documentUrl: '',
    chunks: [],
    pageNumber: 0,
  });
  const [openDocument, setOpenDocument] = useState<boolean>(false);

  //Metadata States
  const [fees, setFees] = useState<Fee[]>([]);

  const [summaryOfFindings, setSummaryOfFindings] = useState<any[]>([]);
  const [provisions, setProvisions] = useState<any[]>([]);
  const [keyTerms, setKeyTerms] = useState<any[]>([]);
  const [redFlags, setRedFlags] = useState<any[]>([]);
  const [missingChecks, setMissingChecks] = useState<any[]>([]);
  const [keyTermsFilters, setKeyTermsFilters] = useState<string[]>([]);
  const [redFlagsFilters, setRedFlagsFilters] = useState<string[]>([]);
  const [missingChecksFilters, setMissingChecksFilters] = useState<string[]>(
    [],
  );
  // const [impactFilters, setImpactFilters] = useState<string[]>([]);
  const [legalTypeFilter, setLegalTypeFilter] = useState<any>([]);
  const [legalFilters, setLegalFilters] = useState<string[]>([]);

  const [importanceFilters, setImportanceFilters] = useState<string[]>([]);
  const [dataByCategory, setDataByCategory] = useState<{
    'Key Terms': any[];
    'Red Flag Checks': any[];
    'Missing Checks': any[];
  }>({
    'Key Terms': [],
    'Red Flag Checks': [],
    'Missing Checks': [],
  });
  const [provisionsBySections, setProvisionsBySections] = useState<any>([]);

  // Compute filterOptions for each category from all provisions
  const filterOptions = React.useMemo(() => {
    const getClauses = (category: string): string[] =>
      Array.from(
        new Set(
          provisions
            ?.filter((item) => item.provisionsCategory === category)
            ?.map((item) => item.clause?.trim())
            ?.filter(Boolean),
        ),
      );

    return {
      'Key Terms': getClauses('Key Terms'),
      'Red Flag Checks': getClauses('Red Flag Checks'),
      'Missing Checks': getClauses('Missing Checks'),
    };
  }, [provisions]);
  // Compute filterOptions for each category from all provisions

  const impactFilterOptions = React.useMemo(() => {
    const getImpact = (category: string): string[] =>
      Array.from(
        new Set(
          provisions
            ?.filter((item) => item.provisionsCategory === category)
            ?.flatMap((item) => {
              const impact = item?.impact;

              if (Array.isArray(impact)) {
                return impact.map((i: any) => i?.trim()).filter(Boolean);
              }

              if (typeof impact === 'string') {
                return impact
                  .split(',')

                  .map((i: any) => i.trim())
                  .filter(Boolean);
              }

              return [];
            }),
        ),
      );

    return {
      'Key Terms': getImpact('Key Terms'),
      'Red Flag Checks': getImpact('Red Flag Checks'),
      'Missing Checks': getImpact('Missing Checks'),
    };
  }, [provisions]);

  const importanceFilterOptions = React.useMemo(() => {
    const getImportance = (category: string): string[] =>
      Array.from(
        new Set(
          provisions
            ?.filter((item) => item.provisionsCategory === category)
            ?.flatMap((item) => {
              const importance = item?.importance;

              if (Array.isArray(importance)) {
                return importance.map((i: any) => i?.trim()).filter(Boolean);
              }

              if (typeof importance === 'string') {
                return importance
                  .split(',')

                  .map((i: any) => i?.trim())
                  .filter(Boolean);
              }

              return [];
            }),
        ),
      );

    return {
      'Key Terms': getImportance('Key Terms'),
      'Red Flag Checks': getImportance('Red Flag Checks'),
      'Missing Checks': getImportance('Missing Checks'),
    };
  }, [provisions]);

  //Matrix States
  const [flaggedOnly, setFlaggedOnly] = useState<true | false | null>(null);
  const [missingOnly, setMissingOnly] = useState<true | false | null>(null);
  const [extractedOnly, setExtractedOnly] = useState<true | false | null>(null);
  const [filterResetKey, setFilterResetKey] = useState(0);
  const [switchValue, setSwitchValue] = useState<boolean>(true);

  //Reports
  const [reports, setReports] = useState<any[]>([]);

  // Chat states
  const [chatMessages, setChatMessages] = useState<ChatMessage[]>([]);
  const [chatLoading, setChatLoading] = useState<boolean>(false);
  // const [chatHistoryLoading, setChatHistoryLoading] = useState<boolean>(false);
  const [chatInitializing, setChatInitializing] = useState<boolean>(false);
  const [isThinking, setIsThinking] = useState<boolean>(false);
  const [streamingResponse, setStreamingResponse] = useState<string>('');
  const [threadId] = useState<string>(uuidv4());
  const [chatKey] = useState<string>(uuidv4()); // Stable key for Chat component
  const [chatSuggestions, setChatSuggestions] = useState<string[]>([]);
  const [legalDoctrineOptions, setLegalDoctrineOptions] = useState<string[]>(
    [],
  );
  const [legalCitationOptions, setLegalCitationOptions] = useState<string[]>(
    [],
  );
  const abortStreamRef = React.useRef<(() => void) | null>(null);

  // Conditionally add "Regenerate Metadata" button
  if (
    loginPageStore.userResponse.role.name === UserAccessConstants.SUPER_ADMIN
  ) {
    customButtonVariant.push('contained');
    customButtonClick.push(() => handleRegenerateMetaData());
    customButtonWidth.push('200px');
    customButtonText.push(messages.REGENERATE_METADATA);
  }

  // Add "View Document" button
  customButtonVariant.push('outlined');
  customButtonClick.push(() => {
    setIsDocumentView(!isDocumentView);
    setSelectedTabIndex(0);
  });
  customButtonWidth.push('160px');
  customButtonText.push(
    isDocumentView ? messages.VIEW_OVERVIEW : messages.VIEW_BASE_DOCUMENT,
  );

  //Functions
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
  };

  const handleNavigationTab = (index: number) => {
    activeIndex === index ? setActiveIndex(-1) : setActiveIndex(index);
  };

  const handleMergeDocuments = () => {
    navigate('/merge-documents');
  };

  const handleDownloadFeeScheduleReport = () => {
    handleDownloadReport(
      'commercialAnalysisReport',
      employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
      isDraft ? '' : contractStore.contractId,
      openSnackbar,
      employerGroupStore?.employerGroupResponseData?.eg_nid[0],
      '',
      '',
      isDraft ? contractStore.draftId : '',
    );
  };

  const handleDownloadComprehensiveReport = () => {
    handleDownloadReport(
      'provisionMatrixReport',
      employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
      isDraft ? '' : contractStore.contractId,
      openSnackbar,
      employerGroupStore?.employerGroupResponseData?.eg_nid[0],
      '',
      '',
      isDraft ? contractStore.draftId : '',
    );
  };

  const getTabsContent = () => {
    const tab = tabList[selectedTabIndex];
    switch (tab) {
      case 'Key Terms':
        return renderMatrixByCategory(
          'Key Terms',
          keyTermsFilters,
          setKeyTermsFilters,
          keyTerms,
        );
      case 'Red Flags':
        return renderMatrixByCategory(
          'Red Flag Checks',
          redFlagsFilters,
          setRedFlagsFilters,
          switchValue ? provisionsBySections : redFlags,
        );

      case 'Missing Provisions':
        return renderMatrixByCategory(
          'Missing Checks',
          missingChecksFilters,
          setMissingChecksFilters,
          switchValue ? provisionsBySections : missingChecks,
        );

      case 'Fees':
        return Fees();
      case 'Summary':
        return <SummaryOfFindings />;
      case 'Compliance Analysis':
        return <Reports />;
      case 'Overview':
        return <Overview />;
      default:
        return null;
    }
  };

  const handleRegenerateReport = async (
    reportName: string,
    contractId: string,
    comparedId?: string,
    draftId?: string,
  ) => {
    openSnackbar(
      'Report re-generation is in progress.To view the regenerated report please come again after some time',
      'info',
      6000,
    );
    await regenerateReport(contractId, reportName);
  };

  const handleRegenerateMetaData = async () => {
    openSnackbar(
      'Metadata re-generation is in progress.To view the regenerated metadata please come again after some time',
      'info',
      6000,
    );
    await regenerateMetadata(contractStore.contractId);
  };

  const reportHandleOnClick = (
    reportName: string,
    contractId?: string,
    status?: any,
    compareId?: string,
    draftId?: string,
  ) => {
    let path;
    if (status === 'Ready') {
      switch (reportName) {
        case 'Gag Clause Prohibition Compliance Check':
          path = GAG_CLAUSE_REPORT;
          break;
        case 'Purchasing Standards Compliance Review':
          path = PURCHASING_STANDARDS_REPORT;
          break;
        case 'Compensation Transparency Compliance Check':
          path = COMPENSATION_TRANSPARENCY_REPORT;
          break;
        case 'Comparison with Stop Loss Agreement':
        case 'Comparison with Administrative Service Agreement':
        case 'Comparison with Summary Plan Description':
        case 'Comparison with Administrative Service Agreement':
          path = INTER_CONTRACT_REPORT;
          break;
        case 'Commercial Evaluation':
          handleDownloadFeeScheduleReport();
          return;
        case 'Comprehensive Report':
          handleDownloadComprehensiveReport();
          return;
        default:
          navigate('/compliance-report');
          return; //under construction page if reportName doesn't match any case
      }
      navigate(path, {
        state: {
          reportName,
          document: `${healthcarePartner} ${contract} Service Agreement`,
          healthcarePartner,
          contract,
          ...(isDraft ? { draftId } : { contractId }),
          draftName,
          isContract: !isDraft,
          isDraft,
          isReportsTab: true,
          compareId: compareId,
          selectedTab: tabList[selectedTabIndex],
        },
      });
    }
  };

  const onClickReference = async (chunks: any[], pageNumber: number) => {
    let documentUrl = masterDoc?.blobUrl ?? null;
    if (!documentUrl) {
      documentUrl = await createBlobUrl(masterDoc?.document_url);
      const updatedMasterDoc = {
        ...masterDoc,
        blobUrl: documentUrl,
      };
      setMasterDoc(updatedMasterDoc);
    }
    setDocumentDetails({ documentUrl, chunks, pageNumber });
    setOpenDocument(true);
  };

  const handleChunkClick = (rowData: any[], matrixData: any[]) => {
    const rawChunkLabel = rowData?.[0] ?? '';

    const chunkName = rawChunkLabel.startsWith('Chunk')
      ? rawChunkLabel.replace(/^Chunk\s*\d+\s*-\s*/, '')
      : rawChunkLabel;
    for (const pageItem of matrixData) {
      const matchedChunk = pageItem.chunks.find(
        (chunk: any) => chunk.chunkName === chunkName,
      );

      if (matchedChunk) {
        const groundingData = matchedChunk.groundingData || [];
        const page = pageItem.page;
        onClickReference(groundingData, page);
        return;
      }
    }
  };

  const handleMatrixActions = (action: string, category: string) => {
    switch (action) {
      // case 'Download Report':
      //   handleDownloadReport(
      //     category === 'Missing Checks'
      //       ? 'missingProvisionsReport'
      //       : 'redFlagsReport',
      //     employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
      //     contractStore.contractId,
      //     openSnackbar,
      //     egNid,
      //   );
      //   break;
      case 'Download CSV':
        handleDownloadCSV(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            '/provisions-csv',
          {
            ...(isDraft
              ? { draft_id: contractStore.draftId }
              : { contract_id: contractStore.contractId }),
            employer: {
              name:
                employerGroupStore?.employerGroupResponseData
                  ?.employer_group_name[0],
              eg_nid: egNid,
            },
            category: category,
          },
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          openSnackbar,
        );
        break;
      case 'Download Report':
        handleDownloadReport(
          'sectionwiseProvisionsReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          isDraft ? '' : contractStore.contractId,
          openSnackbar,
          egNid,
          undefined,
          undefined,
          isDraft ? contractStore.draftId : undefined,
          masterDoc?.document_url,
        );
        break;
      default:
        break;
    }
  };

  const TAB_ORDER = [
    'Key Terms',
    'Fees',
    'Red Flags',
    'Missing Provisions',
    'Summary',
    'Compliance Analysis',
  ];

  //API Calls
  const getContractDetails = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getContractDetails,
        {
          contract_id: contractStore.contractId,
        },
      )
      .then(async (response) => {
        if (response.status === 200) {
          const data = response?.data?.data[0];
          setTabList([]);
          setContractStatus(data?.merge_status ?? '');

          const masterDoc =
            data?.documents.find(
              (doc: any) => doc.document_type === 'Master Document',
            ) ||
            data?.documents.find(
              (doc: any) => doc.document_type === 'Base Document',
            );
          setMasterDoc(masterDoc);

          // extractions: [{ extraction, type: 'Metadata' | 'Report', status }]
          const extractions: Array<{
            extraction: string;
            type: string;
            status: string;
          }> = data?.extractions ?? [];

          if (data?.merge_status === 'Merged') {
            // Metadata tabs: one per metadata extraction that is Ready.
            const readyMetadata = extractions.filter(
              (e) => e.type === 'Metadata' && e.status === 'Ready',
            );

            // Report tabs collapse into a single "Compliance Analysis" tab,
            // shown if the contract has ANY report-type extraction.
            const hasReports = extractions.some((e) => e.type === 'Report');

            const readyTabs: string[] = [
              ...readyMetadata.map((e) => getFeatureTabName(e.extraction)),
              ...(hasReports ? ['Compliance Analysis'] : []),
            ];

            if (readyTabs.length === 0) {
              // Nothing Ready yet -> only Overview.
              setTabList(['Overview']);
            } else {
              // Fixed tab order for every contract type.
              const orderedTabs = [...readyTabs].sort(
                (a, b) => TAB_ORDER.indexOf(a) - TAB_ORDER.indexOf(b),
              );
              setTabList(orderedTabs);
            }
          } else {
            // Not Merged -> Overview only.
            setTabList(['Overview']);
          }

          setLoading(false);

          // No extractions at all -> not an analyzable contract type; show the
          // plain document view (no analysis tabs / custom buttons).
          if (extractions.length === 0) {
            setTabLoading(false);
            setIsDocumentView(true);
            setShowCustomButtons(false);
          }

          const updatedDocuments = await Promise.all(
            data?.documents?.map(async (doc: any) => {
              const documentUrl = await createBlobUrl(doc.document_url);
              return {
                ...doc,
                original_url: doc.document_url,
                document_url: documentUrl,
              };
            }),
          );
          setDocuments(updatedDocuments);
          setDocLoading(false);
        }
      })
      .catch((error) => {
        let errorMessage = 'Some Went Wrong';
        if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = error.response?.data?.error;
        }
        openSnackbar(errorMessage, 'error', 6000);
      });
  };

  const getDraftDetails = async () => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.draftBaseUrl + properties.draftById,
        {
          draft_id: contractStore.draftId,
        },
      )
      .then(async (response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          setTabList([]);
          const masterDoc = {
            document_name: data.document_name,
            document_type: data.document_type,
            document_url: data.document_url,
            markdown_url: data.markdown_url,
          };
          setMasterDoc(masterDoc);
          const features = data?.features ?? [];
          setTabList((prev) => [
            ...prev,

            ...features?.map((feature: string) => getFeatureTabName(feature)),
            ...(data?.reports?.length > 0 ? ['Compliance Analysis'] : []),
          ]);
          const tabsOrder = getOrderedTabsByAgreement(
            data?.service_agreement_id?.service_agreement_name,
          );
          //sort tabList based on tabsOrder
          setTabList((prev) =>
            [...prev].sort(
              (a, b) => tabsOrder.indexOf(a) - tabsOrder.indexOf(b),
            ),
          );

          setLoading(false);
          if (
            ![
              'Third-Party Administrator (TPA)',
              'Administrative Services Only (ASO) Provider',
              'Stop-Loss Insurance Provider',
              'Pharmacy Benefit Manager (PBM)',
              'Provider Network Access',
              'Broker or Consultant',
            ].includes(data?.service_agreement_id?.service_agreement_name)
          ) {
            setTabLoading(false);
            setIsDocumentView(true);
            setShowCustomButtons(false);
          }
          const documentUrl = await createBlobUrl(data.document_url);
          const updatedDocuments = {
            document_name: data.document_name,
            document_type: data.document_type,
            original_url: data.document_url,
            document_url: documentUrl,
            _id: data.draft_id,
          };

          setDocuments([updatedDocuments]);
          setDocLoading(false);
        }
      })
      .catch((error) => {
        let errorMessage = 'Some Went Wrong';
        if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = error.response?.data?.error;
        }
        openSnackbar(errorMessage, 'error', 6000);
      });
  };

  const getMatrixDataBySection = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getMatrixByProvisions,
        {
          ...(isDraft
            ? { draft_id: contractStore.draftId }
            : { contract_id: contractStore.contractId }),
          eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
          document_url: masterDoc?.document_url,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          setProvisionsBySections(response.data.data);
        }
      })
      .catch((error) => {
        openSnackbar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getMatrixData = async () => {
    await axios
      .post(properties.aiqBaseUrl + properties.contractBaseUrl + '/matrix', {
        ...(isDraft
          ? { draft_id: contractStore.draftId }
          : { contract_id: contractStore.contractId }),
        eg_nids: employerGroupStore.employerGroupResponseData.eg_nid,
        document_url: masterDoc?.document_url,
      })
      .then((response) => {
        if (response.status === 200) {
          const data = response?.data?.data[0];
          const provisions = data?.matrix_data || [];

          const fees = data?.matrix_data?.filter(
            (temp: any) => temp.category === 'Fees',
          );
          const keyTerms = formatNewProvisions(
            provisions?.filter((temp: any) => temp.category === 'Key Terms'),
          );
          const redFlags = formatNewProvisions(
            provisions?.filter(
              (temp: any) =>
                temp.category === 'Red Flag Checks' &&
                (temp.deleted === false || temp.deleted === undefined),
            ),
          );
          const missingChecks = formatNewProvisions(
            provisions?.filter(
              (temp: any) =>
                temp.category === 'Missing Checks' &&
                (temp.deleted === false || temp.deleted === undefined),
            ),
          );

          setDataByCategory({
            'Key Terms': keyTerms,
            'Red Flag Checks': redFlags,
            'Missing Checks': missingChecks,
          });
          setProvisions(formatNewProvisions(provisions));
          setKeyTerms(keyTerms);
          setRedFlags(redFlags);
          setMissingChecks(missingChecks);
          const formattedFee = formatFeesProvisions(fees, onClickReference);
          setFees(formattedFee);
        }
      })
      .catch((error) => {
        openSnackbar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getSummaryOfFindings = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getSummaryOfFindings,
        {
          ...(isDraft
            ? { draft_id: contractStore.draftId }
            : { contract_id: contractStore.contractId }),
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          setSummaryOfFindings(data);
        }
      })
      .catch((error) => {
        openSnackbar(error.response?.data?.error, 'error', 6000);
      })
      .finally(() => {});
  };

  const getReports = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getContractReports,
        {
          ...(isDraft
            ? { draft_id: contractStore.draftId }
            : { contract_id: contractStore.contractId }),
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          setReports(data);
        }
      })
      .catch((error) => {
        openSnackbar(error.response?.data?.error, 'error', 6000);
      })
      .finally(() => {});
  };

  const commonApiCalls = async () => {
    const tab = tabList[selectedTabIndex];

    // Helper to show loading and call passed async fn
    const withLoading = async (fn: any) => {
      setTabLoading(true);
      await fn();
      setTabLoading(false);
    };

    // For tabs that always trigger MatrixData fetch if provisions empty
    const matrixTabs = ['Fees', 'Key Terms', 'Red Flags', 'Missing Provisions'];
    const matrixBySectionTabs = ['Red Flags', 'Missing Provisions'];

    if (
      contract === 'Third-Party Administrator (TPA)' ||
      contract === 'Administrative Services Only (ASO) Provider'
    ) {
      switch (tab) {
        case 'Summary':
          if ((summaryOfFindings?.length ?? 0) === 0) {
            await withLoading(getSummaryOfFindings);
          }
          break;
        default:
          break;
      }
    }

    if (matrixTabs.includes(tab) && (provisions?.length ?? 0) === 0) {
      // Common cases for other contracts or fall-through for StopLoss
      await withLoading(getMatrixData);
    } else if (tab === 'Compliance Analysis' && (reports?.length ?? 0) === 0) {
      await withLoading(getReports);
    }
    if (matrixBySectionTabs.includes(tab)) {
      setSwitchValue(true);
      if ((provisionsBySections?.length ?? 0) === 0) {
        await withLoading(getMatrixDataBySection);
      }
      // Common cases for other contracts or fall-through for StopLoss
    }
  };

  const agreementApiCalls = async () => {
    await commonApiCalls();
  };

  const ApiCalls = async () => {
    if (isDraft) {
      getDraftDetails();
    } else {
      await getContractDetails();
    }
  };

  const fetchFiduciaryList = async () => {
    const result = await axios.get(
      properties.aiqBaseUrl +
        properties.playbookAndStandard +
        properties.getFiduciaryList,
      // {
      //   params: { eg_nid: egNid },
      // },
    );
    const data = result.data?.data || {};

    setLegalDoctrineOptions(data.legal_doctrine || []);
    setLegalCitationOptions(data.legal_citation || []);
  };

  //UseEffects
  useEffect(() => {
    if (!selectedTabFromExp || tabList.length === 0) {
      return;
    }

    const index = tabList.indexOf(selectedTabFromExp);
    if (index !== -1) {
      setSelectedTabIndex(index);
    }
  }, [selectedTabFromExp, tabList]);

  useEffect(() => {
    if (contractStore?.contractId) {
      ApiCalls();
    }
  }, [contractStore.contractId]);

  useEffect(() => {
    if (contractStore?.draftId) {
      ApiCalls();
    }
  }, [contractStore.draftId]);

  useEffect(() => {
    if (contract) {
      agreementApiCalls();
    }
  }, [selectedTabIndex, tabList]);

  // Chat functions
  const loadChatHistory = async () => {
    if (!selectedDoc?.original_url || !selectedDoc?._id) {
      return;
    }

    // First initialize the chat with file_id and file_type
    setChatInitializing(true);
    try {
      await initialiseChatWithFile(selectedDoc._id, 'contract');
    } catch (error: any) {
      console.error('Error initializing chat:', error);
      // Continue even if initialization fails
    } finally {
      setChatInitializing(false);
    }

    // Then load chat history
    // setChatHistoryLoading(true);
    try {
      // Use original_url (actual document URL) not document_url (blob URL)
      const response = await getChatHistory(selectedDoc.original_url);
      setChatMessages(response.data || []);
    } catch (error: any) {
      console.error('Error loading chat history:', error);
      // Silently fail - just start with empty chat history
      setChatMessages([]);
    } finally {
      // setChatHistoryLoading(false);
    }
  };

  const handleSendMessage = async (message?: string) => {
    const userMessage = message?.trim();

    if (!userMessage) {
      return;
    }

    if (!selectedDoc?.original_url) {
      return;
    }

    const fileUrl = selectedDoc.original_url;
    const fileId = selectedDoc._id;

    // Create user message
    const userMessageId = uuidv4();

    const newUserMessage: ChatMessage = {
      _id: userMessageId,
      file_url: fileUrl,
      file_id: fileId,
      message: userMessage,
      response: '',
      message_type: 'user',
      status: 'sent',
      createdAt: new Date().toISOString(),
    };

    // Add user message to chat immediately
    setChatMessages((prev) => [...prev, newUserMessage]);
    setIsThinking(true);
    setChatLoading(true);
    setStreamingResponse('');

    // Build messages array for LangGraph API
    const allMessages = [
      ...chatMessages.flatMap((msg) => {
        const msgs = [];
        if (msg.message) {
          msgs.push({
            id: `${msg._id}-user`,
            type: 'human' as const,
            content: msg.message,
          });
        }
        if (msg.response) {
          msgs.push({
            id: `${msg._id}-assistant`,
            type: 'ai' as const,
            content: msg.response,
          });
        }
        return msgs;
      }),
      {
        id: userMessageId,
        type: 'human' as const,
        content: userMessage,
      },
    ];

    try {
      // Include file metadata in the context
      const fileMetadata = {
        file_url: fileUrl,
        file_id: fileId,
        document_name: selectedDoc.document_name,
        contract_id: contractStore.contractId,
        contract_type: contract,
      };

      // Call wait endpoint (non-streaming)
      const response = await sendChatMessage(
        threadId,
        allMessages,
        fileMetadata,
      );

      // Extract the assistant's response
      const messages = response?.values?.messages || [];
      const lastMessage = messages[messages.length - 1];
      const responseContent = lastMessage?.content || 'No response received';

      // Extract suggestions from the response
      const suggestions = response?.values?.suggestions || [];
      setChatSuggestions(suggestions);

      // Update the existing user message with the response
      setChatMessages((prev) =>
        prev.map((msg) =>
          msg._id === userMessageId
            ? { ...msg, response: responseContent, status: 'completed' }
            : msg,
        ),
      );

      setIsThinking(false);
      setChatLoading(false);
    } catch (error: any) {
      console.error('Error sending message:', error);

      // Update the existing user message with error response
      setChatMessages((prev) =>
        prev.map((msg) =>
          msg._id === userMessageId
            ? {
                ...msg,
                response:
                  'I encountered an error processing your message. Please try again.',
                status: 'failed',
              }
            : msg,
        ),
      );
      setIsThinking(false);
      setChatLoading(false);
    }
  };

  // Load chat history when document changes
  useEffect(() => {
    if (selectedDoc?.original_url) {
      loadChatHistory();
    }
  }, [selectedDoc?.original_url]);

  useEffect(() => {
    const selectedDocument =
      documents?.find((doc) => doc._id === contractStore.documentSelected) ||
      documents?.find((item) => item?.document_type === 'Base Document');

    if (selectedDocument) {
      setSelectedDoc({
        document_name: selectedDocument?.document_name,
        document_url: selectedDocument?.document_url,
        original_url: selectedDocument?.original_url,
        _id: selectedDocument?._id,
      });
    }
  }, [documents]);

  // Cleanup streaming on unmount
  React.useEffect(() => {
    return () => {
      if (abortStreamRef.current) {
        abortStreamRef.current();
      }
    };
  }, []);

  useEffect(() => {
    fetchFiduciaryList();
  }, []);

  useEffect(() => {}, [legalTypeFilter, legalFilters]);

  //components
  const Overview = () => {
    return contractStatus === 'Not Merged' ? (
      <Grid>
        <GifWithLabels
          rootStyles={{
            height: '400px',
          }}
          mainLabel={
            <Typography
              fontSize="16px"
              fontType="medium"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.highemphasis}
            >
              Contract has Amendments that are are not merged. Merge to generate
              a master document.
            </Typography>
          }
          subLabel={
            <Button label={'Merge Documents'} onClick={handleMergeDocuments} />
          }
          gifUrl={MergeDocuments}
        />
      </Grid>
    ) : (
      <Grid style={{ height: '400px' }}>
        <GifWithLabels
          rootStyles={{
            height: '400px',
          }}
          mainLabel={
            <Typography
              fontSize="16px"
              fontType="medium"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.highemphasis}
            >
              Processing of the document is underway. Please revisit this screen
              shortly.
            </Typography>
          }
          subLabel={undefined}
          gifUrl={DataExtraction}
        />
      </Grid>
    );
  };

  const ChatSection = () => {
    // Show initializing loader
    if (chatInitializing) {
      return (
        <Grid className={classes.chatSection}>
          <Grid
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '519px',
              gap: '16px',
            }}
          >
            <Typography
              fontSize="14px"
              lineHeight="21px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              Initialising chat...
            </Typography>
          </Grid>
        </Grid>
      );
    }

    // Format messages for the Chat component
    const formattedMessages: any[] = [];

    chatMessages.forEach((msg) => {
      // Add user message
      if (msg.message) {
        formattedMessages.push({
          id: `${msg._id}-user`,
          text: msg.message,
          isUser: true,
          timestamp: msg.createdAt ? new Date(msg.createdAt) : new Date(),
        });
      }
      // Add assistant response with Markdown component
      if (msg.response) {
        formattedMessages.push({
          id: `${msg._id}-assistant`,
          text: msg.response,
          isUser: false,
          timestamp: msg.createdAt ? new Date(msg.createdAt) : new Date(),
          component: <MarkdownMessage content={msg.response} />,
        });
      }
    });

    // Add streaming response if available
    if (streamingResponse && !isThinking) {
      formattedMessages.push({
        id: 'streaming',
        text: streamingResponse,
        isUser: false,
        timestamp: new Date(),
        component: <MarkdownMessage content={streamingResponse} />,
      });
    }

    // Add thinking message if loading
    if (isThinking && !streamingResponse) {
      formattedMessages.push({
        id: 'thinking',
        text: 'Thinking...',
        isUser: false,
        timestamp: new Date(),
        isThinking: true,
      });
    }

    return (
      <Grid className={classes.chatSection}>
        <Chat
          key={chatKey}
          height="519px"
          headerTitle="Chat about document"
          headerSubtitle={selectedDoc?.document_name || ''}
          disclaimerText="AI can make mistakes, please verify your answers"
          messages={formattedMessages}
          onSendMessage={handleSendMessage}
          isGenerating={chatLoading}
          suggestions={chatSuggestions}
        />
      </Grid>
    );
  };

  const MetadataContent = () => {
    return (
      <Grid className={classes.metadataRoot}>
        <TabSelection
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={handleSelectedIndex}
          tabList={tabList}
          margin="0px"
        />
        <Grid
          className={classes.tabs}
          style={{ paddingRight: openDocument ? '20px' : '75px' }}
        >
          <Grid
            className={classes.tabContent}
            style={{ width: openDocument ? '55%' : '100%' }}
          >
            {tabLoading ? loader : getTabsContent()}
          </Grid>
          {openDocument && (
            <Grid className={classes.rightView}>
              <PdfHighlighter
                key={`${documentDetails?.documentUrl}-${documentDetails?.pageNumber}-${documentDetails?.chunks?.length}`}
                pdfUrl={documentDetails?.documentUrl}
                chunks={documentDetails?.chunks}
                highlightIds={documentDetails?.chunks.map(
                  (item: any) => item.chunk_id,
                )}
                pageNumber={documentDetails?.pageNumber}
                contentStyles={{ height: '480px' }}
                onClose={() => setOpenDocument(false)}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  };

  const DocumentsContent = () => {
    return (
      <>
        {docLoading ? (
          <Loader />
        ) : (
          <Grid className={classes.documentViewRoot}>
            <Grid className={classes.documentViewContainer}>
              <Grid className={classes.documentSection}>
                <Grid className={classes.documentViewGrid}>
                  <Grid className={classes.documentDropdown}>
                    <Typography
                      fontSize="14px"
                      lineHeight="22.4px"
                      fontType="medium"
                      textColor={patientAccessTheme.palette.text.mediumemphasis}
                      margin="0px 8px 0px 0px"
                    >
                      {'Documents:'}
                    </Typography>
                    <DashedStandardDropdown
                      options={documents?.map((item: any) => item?._id)}
                      displayValue={documents?.map((item: any) => {
                        return `${item?.document_name.slice(0, 70)}... (${
                          item.document_type
                        })`;
                      })}
                      handleChange={(event) => {
                        const docName = event?.target?.value;
                        const selectedDocument = documents?.find(
                          (item: any) => docName === item?._id,
                        );
                        if (selectedDocument) {
                          setSelectedDoc({
                            document_name: selectedDocument?.document_name,
                            document_url: selectedDocument?.document_url,
                            original_url: selectedDocument?.original_url,
                            _id: selectedDocument?._id,
                          });
                        }
                      }}
                      value={selectedDoc?._id}
                    />
                  </Grid>
                  <Typography
                    fontSize="14px"
                    lineHeight="24px"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                    margin="16px 0px"
                  >
                    {selectedDoc?.document_name}
                  </Typography>
                  <Grid
                    style={{
                      marginTop: '36px',
                    }}
                  >
                    {selectedDoc?.document_url !== '' && (
                      <Worker workerUrl={PDF_WORKER_URL}>
                        <Viewer
                          fileUrl={selectedDoc?.document_url}
                          renderPage={(props) => (
                            <>
                              {props.canvasLayer.children}
                              {props.textLayer.children}
                              {/* remove annotationLayer */}
                            </>
                          )}
                        />
                      </Worker>
                    )}
                    {selectedDoc?.document_url === '' && (
                      <NoDataVisual content="NO FILE FOUND" />
                    )}
                  </Grid>
                </Grid>
              </Grid>
              {!isDraft && <ChatSection />}
            </Grid>
            <ContractSideNavigationBar
              tabs={messages.CONTRACT_NAVIGATION_TABS}
              icons={icons}
              activeIndex={activeIndex}
              handleOnClick={handleNavigationTab}
            />
          </Grid>
        )}
      </>
    );
  };

  const SummaryOfFindings = () => {
    return (
      <ProvisionMatrix
        title="Summary"
        subTitle=""
        showFilters={false}
        matrixColumns={summaryColumns}
        matrixData={summaryOfFindings}
        showRegenerate={false}
        groupByCategory={false}
      />
    );
  };

  const resetRedFlagFilters = (resetKey = false) => {
    setFlaggedOnly(null);
    setRedFlagsFilters([]);
    setLegalFilters([]);
    setLegalTypeFilter(null);
    setImportanceFilters([]);
    // setImpactFilters([]);
    setRedFlags(dataByCategory['Red Flag Checks']);
    if (resetKey) {
      setFilterResetKey((prev) => prev + 1);
    }
  };

  const resetMissingFlagFilters = (resetKey = false) => {
    setMissingOnly(null);
    setMissingChecksFilters([]);
    setLegalFilters([]);
    setLegalTypeFilter(null);
    setImportanceFilters([]);
    // setImpactFilters([]);
    setMissingChecks(dataByCategory['Missing Checks']);
    if (resetKey) {
      setFilterResetKey((prev) => prev + 1);
    }
  };

  const resetKeyTermsFilters = (resetKey = false) => {
    setExtractedOnly(null);
    setKeyTermsFilters([]);
    // setImpactFilters([]);
    setKeyTerms(dataByCategory['Key Terms']);

    if (resetKey) {
      setFilterResetKey((prev) => prev + 1);
    }
  };

  const getToggle = (category: string) => {
    switch (category) {
      case 'Red Flag Checks':
        return (
          <Grid style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <DynamicFilter
              filterOptions={[
                {
                  label: 'Flagged Issues',
                  options: ['Flagged', 'Not Flagged'],
                  selected:
                    flaggedOnly === null
                      ? ''
                      : flaggedOnly === true
                      ? 'Flagged'
                      : 'Not Flagged',
                  onChange: (value: string) => {
                    resetRedFlagFilters();
                    if (value === 'Flagged') {
                      setFlaggedOnly(true);
                    } else {
                      setFlaggedOnly(false);
                    }
                  },
                },
                {
                  label: 'Clause Topic',
                  options: filterOptions[category],
                  selected: redFlagsFilters,
                  isSelectMultiple: true,
                  onChange: (values: string[]) => {
                    resetRedFlagFilters();
                    setRedFlagsFilters(values);
                    // Apply filters immediately
                    const filteredData = [...dataByCategory['Red Flag Checks']];
                    let filteredProvisions = [...filteredData];

                    if (values?.length) {
                      filteredProvisions = filteredData.filter(
                        (provision: MatrixData) =>
                          values.includes(provision?.clause),
                      );
                    }

                    setRedFlags(filteredProvisions);
                  },
                },
                {
                  label: 'Legal Type',
                  options: [],
                  selected: null,
                  levels: [
                    {
                      label: 'Legal Type',
                      options: ['Legal Doctrine', 'Legal Citation'],
                    },
                    {
                      label: 'Select Options',
                      options: (previousValue: string) => {
                        if (previousValue === 'Legal Doctrine') {
                          return legalDoctrineOptions;
                        } else if (previousValue === 'Legal Citation') {
                          return legalCitationOptions;
                        }
                        return [];
                      },
                      isMultiSelect: true,
                    },
                  ],

                  onChange: (selections: string[]) => {
                    const [filterType, selectedValues] = selections;

                    const values = selectedValues
                      ? selectedValues.split(',').map((v) => v.trim())
                      : [];

                    setLegalTypeFilter(filterType);
                    setLegalFilters(values);

                    const filteredData = [...dataByCategory['Red Flag Checks']];

                    let filteredProvisions = [...filteredData];

                    if (filterType && values.length) {
                      filteredProvisions = filteredData.filter(
                        (provision: MatrixData) => {
                          let fieldValues: string[] = [];

                          if (filterType === 'Legal Doctrine') {
                            fieldValues = provision.legal_doctorine ?? [];
                          }

                          if (filterType === 'Legal Citation') {
                            fieldValues = provision.legal_citation ?? [];
                          }

                          return fieldValues.some((val) =>
                            values.includes(val),
                          );
                        },
                      );
                    }

                    setRedFlags(filteredProvisions);
                  },
                },
                {
                  label: 'Importance',
                  options: importanceFilterOptions[category],
                  selected: importanceFilters,
                  isSelectMultiple: true,
                  onChange: (values: string[]) => {
                    setImportanceFilters(values);
                    const filteredData = [...dataByCategory['Red Flag Checks']];
                    let filteredProvisions = [...filteredData];
                    if (values?.length) {
                      filteredProvisions = filteredData.filter(
                        (provision: MatrixData) => {
                          const importance = Array.isArray(provision.importance)
                            ? provision.importance
                            : typeof provision.importance === 'string'
                            ? provision.importance
                                .split(',')
                                .map((i: string) => i.trim())
                            : [];

                          return importance.some((importance: string) =>
                            values.includes(importance),
                          );
                        },
                      );
                    }
                    setRedFlags(filteredProvisions);
                  },
                },
              ]}
              resetKey={filterResetKey}
            />
            <Button
              label={'Reset Filters'}
              onClick={() => {
                resetRedFlagFilters(true);
              }}
            />
          </Grid>
        );
      case 'Missing Checks':
        return (
          <Grid style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <DynamicFilter
              filterOptions={[
                {
                  label: 'Missing Checks',
                  options: ['Flagged', 'Not Flagged'],
                  selected:
                    missingOnly === null
                      ? ''
                      : missingOnly === true
                      ? 'Flagged'
                      : 'Not Flagged',
                  onChange: (value: string) => {
                    resetMissingFlagFilters();
                    if (value === 'Flagged') {
                      setMissingOnly(true);
                    } else {
                      setMissingOnly(false);
                    }
                  },
                },
                {
                  label: 'Clause Topic',
                  options: filterOptions[category],
                  selected: missingChecksFilters,
                  isSelectMultiple: true,
                  onChange: (values: string[]) => {
                    resetMissingFlagFilters();
                    setMissingChecksFilters(values);
                    // Apply filters immediately
                    const filteredData = [...dataByCategory['Missing Checks']];
                    let filteredProvisions = [...filteredData];

                    if (values?.length) {
                      filteredProvisions = filteredData.filter(
                        (provision: MatrixData) =>
                          values.includes(provision?.clause),
                      );
                    }
                    setMissingChecks(filteredProvisions);
                  },
                },
                // {
                //   label: 'Impact',
                //   options: impactFilterOptions[category],
                //   selected: impactFilters,
                //   isSelectMultiple: true,
                //   onChange: (values: string[]) => {
                //     resetMissingFlagFilters();
                //     setImpactFilters(values);
                //     const filteredData = [...dataByCategory['Missing Checks']];
                //     let filteredProvisions = [...filteredData];
                //     if (values?.length) {
                //       filteredProvisions = filteredData.filter(
                //         (provision: MatrixData) => {
                //           const impacts = Array.isArray(provision.impact)
                //             ? provision.impact
                //             : typeof provision.impact === 'string'
                //             ? provision.impact
                //                 .split(',')
                //                 .map((i: string) => i.trim())
                //             : [];
                //           return impacts.some((impact: string) =>
                //             values.includes(impact),
                //           );
                //         },
                //       );
                //     }
                //     setMissingChecks(filteredProvisions);
                //   },
                // },
                {
                  label: 'Legal Type',
                  options: [],
                  selected: null,
                  levels: [
                    {
                      label: 'Legal Type',
                      options: ['Legal Doctrine', 'Legal Citation'],
                    },
                    {
                      label: 'Select Options',
                      options: (previousValue: string) => {
                        if (previousValue === 'Legal Doctrine') {
                          return legalDoctrineOptions;
                        } else if (previousValue === 'Legal Citation') {
                          return legalCitationOptions;
                        }
                        return [];
                      },
                      isMultiSelect: true,
                    },
                  ],

                  onChange: (selections: string[]) => {
                    const [filterType, selectedValues] = selections;

                    const values = selectedValues
                      ? selectedValues.split(',').map((v) => v?.trim())
                      : [];

                    setLegalTypeFilter(filterType);
                    setLegalFilters(values);

                    const filteredData = [...dataByCategory['Missing Checks']];

                    let filteredProvisions = [...filteredData];

                    if (filterType && values.length) {
                      filteredProvisions = filteredData.filter(
                        (provision: MatrixData) => {
                          let fieldValues: string[] = [];

                          if (filterType === 'Legal Doctrine') {
                            fieldValues = provision.legal_doctorine ?? [];
                          }

                          if (filterType === 'Legal Citation') {
                            fieldValues = provision.legal_citation ?? [];
                          }

                          return fieldValues.some((val) =>
                            values.includes(val),
                          );
                        },
                      );
                    }

                    setMissingChecks(filteredProvisions);
                  },
                },
                {
                  label: 'Importance',
                  options: importanceFilterOptions[category],
                  selected: importanceFilters,
                  isSelectMultiple: true,
                  onChange: (values: string[]) => {
                    setImportanceFilters(values);
                    const filteredData = [...dataByCategory['Missing Checks']];
                    let filteredProvisions = [...filteredData];
                    if (values?.length) {
                      filteredProvisions = filteredData.filter(
                        (provision: MatrixData) => {
                          const impacts = Array.isArray(provision.importance)
                            ? provision.importance
                            : typeof provision.importance === 'string'
                            ? provision.importance
                                .split(',')
                                .map((i: string) => i.trim())
                            : [];

                          return impacts.some((importance: string) =>
                            values.includes(importance),
                          );
                        },
                      );
                    }
                    setMissingChecks(filteredProvisions);
                  },
                },
              ]}
              resetKey={filterResetKey}
            />
            <Button
              label={'Reset Filters'}
              onClick={() => {
                resetMissingFlagFilters(true);
              }}
            />
          </Grid>
        );
      case 'Key Terms':
        return (
          <Grid style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <DynamicFilter
              filterOptions={[
                {
                  label: 'Key Terms',
                  options: ['Included', 'Excluded'],
                  selected:
                    extractedOnly === null
                      ? ''
                      : extractedOnly === true
                      ? 'Included'
                      : 'Excluded',
                  onChange: (value: string) => {
                    resetKeyTermsFilters();
                    if (value === 'Included') {
                      setExtractedOnly(true);
                    } else {
                      setExtractedOnly(false);
                    }
                  },
                },
                {
                  label: 'Clause Topic',
                  options: filterOptions[category],
                  selected: keyTermsFilters,
                  isSelectMultiple: true,
                  onChange: (values: string[]) => {
                    resetKeyTermsFilters();
                    setKeyTermsFilters(values);
                    const filteredData = [...dataByCategory['Key Terms']];
                    let filteredProvisions = [...filteredData];

                    if (values?.length) {
                      filteredProvisions = filteredData.filter(
                        (provision: MatrixData) =>
                          values.includes(provision?.clause),
                      );
                    }
                    setKeyTerms(filteredProvisions);
                  },
                },
                {
                  label: 'Importance',
                  options: importanceFilterOptions[category],
                  selected: importanceFilters,
                  isSelectMultiple: true,
                  onChange: (values: string[]) => {
                    setImportanceFilters(values);
                    const filteredData = [...dataByCategory['Key Terms']];
                    let filteredProvisions = [...filteredData];
                    if (values?.length) {
                      filteredProvisions = filteredData.filter(
                        (provision: MatrixData) => {
                          const impacts = Array.isArray(provision.importance)
                            ? provision.importance
                            : typeof provision.importance === 'string'
                            ? provision.importance
                                .split(',')
                                .map((i: string) => i.trim())
                            : [];

                          return impacts.some((importance: string) =>
                            values.includes(importance),
                          );
                        },
                      );
                    }
                    setKeyTerms(filteredProvisions);
                  },
                },
              ]}
              resetKey={filterResetKey}
            />
            <Button
              label={'Reset Filters'}
              onClick={() => {
                resetKeyTermsFilters(true);
              }}
              variant="outlined"
            />
          </Grid>
        );
      default:
        return undefined;
    }
  };

  const renderMatrixByCategory = (
    category: 'Key Terms' | 'Red Flag Checks' | 'Missing Checks',
    selectedFilters: string[],
    setSelectedFilters: React.Dispatch<React.SetStateAction<string[]>>,
    matrixData: any[],
  ) => {
    let filteredData = [...matrixData];
    if (switchValue && category !== 'Key Terms') {
      const filters = {
        flaggedOnly,
        missingOnly,
        selectedFilters,
        legalTypeFilter,
        legalFilters,
        importanceFilters,
      };
      filteredData = formatMatrixData(matrixData, category, filters);
    } else {
      if (category === 'Red Flag Checks' && flaggedOnly) {
        filteredData = filteredData.filter((item) => item.value === true);
      }

      if (category === 'Missing Checks' && missingOnly) {
        filteredData = filteredData.filter((item) => item.value !== true);
      }
      if (category === 'Key Terms' && extractedOnly) {
        filteredData = filteredData.filter(
          (item) => ![undefined, '', '-']?.includes(item.value),
        );
      }
      const priorityOrder = ['Introduction', 'Term'];

      filteredData.sort((a, b) => {
        const aIndex = priorityOrder.indexOf(a.category);
        const bIndex = priorityOrder.indexOf(b.category);

        // If both categories are in the priority list, follow that order
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex;
        }

        // If only one is in the list, it comes first
        if (aIndex !== -1) {
          return -1;
        }
        if (bIndex !== -1) {
          return 1;
        }

        // Otherwise, sort alphabetically among the rest
        return a?.category?.localeCompare(b.category);
      });

      filteredData = filteredData.map((item) => {
        let displayValue = item.value;

        switch (category) {
          case 'Red Flag Checks':
            displayValue = item.value === true ? 'Flagged' : 'No';
            break;
          case 'Missing Checks':
            displayValue = item.value === true ? 'Yes' : 'Missing';
            break;
          default:
            filteredData = filteredData;
        }
        return {
          ...item,
          value: (
            <Box
              key={`${item.provision_name}-value`}
              className={classes.parameterBox}
            >
              <Typography fontSize="14px" lineHeight="24px" component="div">
                <span>
                  {typeof displayValue === 'string'
                    ? displayValue.charAt(0).toUpperCase() +
                      displayValue.slice(1)
                    : displayValue}
                </span>
                {item?.chunks?.length > 0 &&
                  Array.from(
                    new Map(
                      item?.chunks?.map((ref: any) => {
                        const key =
                          ref?.grounding?.extractions?.reference ??
                          ref?.grounding?.page;

                        return [key, ref];
                      }),
                    ).values(),
                  ).map((ref: any, ind: number, arr: any[]) => {
                    const reference = ref?.grounding?.extractions?.reference;
                    const page = ref?.grounding?.page;

                    if (reference || (page !== null && page !== undefined)) {
                      return (
                        <DottedText
                          key={ref.chunk_id}
                          text={
                            reference
                              ? `${reference}`
                              : `PgNo:${page + 1}${
                                  ind < arr.length - 1 ? ',' : ''
                                }`
                          }
                          styles={{ paddingLeft: '5px' }}
                          onClick={() => onClickReference(item.chunks, page)}
                        />
                      );
                    }

                    return null;
                  })}
              </Typography>
            </Box>
          ),
        };
      });
    }

    return (
      <ProvisionMatrix
        title={category}
        matrixColumns={matrixColumns}
        matrixData={filteredData}
        showFilters={false}
        // handleMatrixSort={(fieldName) => handleMatrixSort(fieldName, category)}
        // matrixSortConfig={matrixSortConfig}
        showRegenerate={false}
        // handleRegenerateProvisionMatrix={() =>
        //   handleRegenerateProvisionMatrix(category)
        // }
        // filterOptions={filterOptions[category] || []}
        // selectedFilters={selectedFilters}
        // setSelectedFilters={setSelectedFilters}
        // handleAddFilters={() => handleAddFilters(category)}
        showSwitch={
          category === 'Red Flag Checks' || category === 'Missing Checks'
        }
        switchValue={switchValue}
        setSwitchValue={setSwitchValue}
        handleChunkClick={(rowData) => handleChunkClick(rowData, filteredData)}
        toggle={getToggle(category)}
        actionsMenuItems={
          category === 'Red Flag Checks' || category === 'Missing Checks'
            ? [
                {
                  label: 'Download Report',
                  icon: (
                    <Contract
                      width={'20px'}
                      height={'20px'}
                      color={patientAccessTheme.palette.primary.main}
                    />
                  ),
                },
                {
                  label: 'Download CSV',
                  icon: <SvgTable width={'20px'} height={'20px'} />,
                },
                // {
                //   label: 'Download Detailed Report',
                //   icon: (
                //     <Contract
                //       width={'20px'}
                //       height={'20px'}
                //       color={patientAccessTheme.palette.primary.main}
                //     />
                //   ),
                // },
              ]
            : []
        }
        handleMatrixActions={(action) => handleMatrixActions(action, category)}
        groupByCategory={
          !filteredData.every((item) => item.category === undefined)
        }
      />
    );
  };

  const Fees = () => {
    return (
      <ProvisionMatrix
        title="Fees"
        subTitle="Fee details of services offered under agreement"
        showFilters={false}
        matrixColumns={feesColumns}
        matrixData={fees}
        showRegenerate={false}
        // handleRegenerateProvisionMatrix={() =>
        //   handleRegenerateProvisionMatrix('Fees')
        // }
        groupByCategory={false}
      />
    );
  };

  const Reports = () => {
    let categories: any[] = [];
    switch (contract) {
      case 'Third-Party Administrator (TPA)':
      case 'Administrative Services Only (ASO) Provider':
        categories = messages.ASO_REPORT_CATEGORIES;
        break;
      case 'Stop-Loss Insurance Provider':
        categories = messages.STOPLOSS_REPORT_CATEGORIES;
        break;
      case 'Direct Contract Provider (or Group)': // ← ADD THIS CASE
        categories = messages.DIRECT_CONTRACT_REPORT_CATEGORIES; // or reuse ASO if same
        break;
      case 'Broker or Consultant':
      case 'Pharmacy Benefit Manager (PBM)':
      case 'Provider Network Access':
        categories = messages.ASO_REPORT_CATEGORIES;
        break;
      default:
        break;
    }
    return (
      <Grid>
        {categories?.map((category: any, categoryIndex: number) => {
          const hasMatchingReports = reports?.some((item: any) =>
            category?.reports?.includes(item?.report_name),
          );
          return (
            <div key={categoryIndex}>
              {hasMatchingReports && (
                <Typography
                  fontSize="14px"
                  lineHeight="24px"
                  fontType="semiBold"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  margin="0px 0px 16px 0px"
                >
                  {category?.category}
                </Typography>
              )}
              <Grid className={classes.reports}>
                {reports?.length > 0 &&
                  reports?.map((item: any, index: number) => {
                    return (
                      <>
                        {category?.reports?.includes(item?.report_name) && (
                          <div key={index} className={classes.eachReport}>
                            <WasteCalculatorCard
                              height="328px"
                              width="358px"
                              title={item?.report_name}
                              subTitle={item?.description || ''}
                              image={ContractReport}
                              titleFont="16px"
                              showExternalLink={false}
                              showTooltip={true}
                              handleOnClick={() =>
                                reportHandleOnClick(
                                  item?.report_name,
                                  item?.contract_id,
                                  item?.status,
                                  item?.compare_agreement_id,
                                  item?.draft_id,
                                )
                              }
                              truncatedSubTitleLength={90}
                              showReportButton={true}
                              reportButtonText={getReportStatusText(
                                item?.status,
                                item?.report_name,
                              )}
                              reportStatus={item?.status}
                              imageHeight="164px"
                              showRegenerateButton={
                                loginPageStore.userResponse.role.name ===
                                  UserAccessConstants.SUPER_ADMIN &&
                                item?.report_name !== 'Comprehensive Report'
                              }
                              regenerateTitle="Regenerate"
                              handleRegenerate={() => {
                                handleRegenerateReport(
                                  item?.report_name,
                                  item?.contract_id,
                                  item?.compare_agreement_id,
                                  item?.draft_id,
                                );
                              }}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}
                {reports.length === 0 && (
                  <NoDataVisual content="NO REPORTS FOUND" />
                )}
              </Grid>
            </div>
          );
        })}
      </Grid>
    );
  };

  return (
    <>
      {loading ? (
        loader
      ) : (
        <Grid>
          <Grid className={classes.breadcrumbs}>
            <Breadcrumbs itemList={breadcrumbsItemsList} />
          </Grid>
          <Grid className={classes.titleSubtitle}>
            <PageTitleAndSubTitle
              title={
                <Tooltip
                  title={`${healthcarePartner} ${contract} Service Agreement`}
                >
                  <div>
                    <Typography
                      fontSize="18px"
                      lineHeight="22px"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                      fontType="semiBold"
                      className={classes.title}
                    >
                      {`${healthcarePartner} ${contract} Service Agreement`}
                    </Typography>
                  </div>
                </Tooltip>
              }
              subTitle={
                isDraft
                  ? ''
                  : `This agreement is between ${employerGroupStore?.employerGroupResponseData?.employer_group_name} and ${healthcarePartner}`
              }
              subTitleStyles={{
                width: '62vw',
              }}
              showDownloadButton={false}
              showQueryDataButton={false}
              customButton={showCustomButtons}
              customButtonText={customButtonText}
              customButtonVariant={customButtonVariant}
              customButtonClick={customButtonClick}
              customButtonWidth={customButtonWidth}
            />
          </Grid>
          <Grid>{isDocumentView ? DocumentsContent() : MetadataContent()}</Grid>
        </Grid>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
});

export default ContractDetails;
